import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEyedropper2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEyedropper2"><Path fillRule="evenodd" clipRule="evenodd" d="M17.0001 1.93939L22.0608 7L16.5608 12.5L18.0608 14L17.0001 15.0607L15.5001 13.5607L8.06066 21H3V15.9393L10.4394 8.49994L8.93945 7L10.0001 5.93934L11.5001 7.43928L17.0001 1.93939ZM14.4394 12.4999L11.5001 9.5606L6.06065 15H11.9393L14.4394 12.4999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEyedropper2;
